export const getSnackbarProps = (state) => state.snackbar.props;
export const isSnackbarOpened = (state) => state.snackbar.open;
